import { useState } from "react";
import { DateTimePicker } from "@/components/admin/DateTimePicker";
import { NewPlaceCategory } from "@/components/admin/NewPlaceCategory";
import { ImportFromLink } from "@/components/admin/ImportFromLink";
import { EventTypePicker } from "@/components/admin/EventTypePicker";
import { AreaField, Field, TextField, contentToText, embedsToText, textToContent, textToEmbeds } from "@/components/admin/fields";

export const EventForm = ({ initial, onSubmit, submitting, hideImport = false }) => {
  const [f, setF] = useState({
    title: "", date: "", venue: "", address: "", city: "", image: "", ticket_url: "", excerpt: "",
    ...initial,
    place_category: initial?.place_category || "salles",
    types: initial?.types || [],
    contentText: contentToText(initial?.content),
    embedsText: embedsToText(initial?.embeds),
  });
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const applyImport = (d) => setF((s) => {
    const pick = (k) => d?.[k] || s[k];
    return {
      ...s, title: pick("title"), date: pick("date"), venue: pick("venue"), address: pick("address"), city: pick("city"),
      image: pick("image"), ticket_url: d?.ticket_url || d?.source_url || s.ticket_url, excerpt: pick("excerpt"),
      place_category: pick("place_category"), types: d?.types?.length ? d.types : s.types,
      contentText: Array.isArray(d?.content) && d.content.length ? contentToText(d.content) : s.contentText,
    };
  });

  const submit = (e) => {
    e.preventDefault();
    const { contentText, embedsText, id, slug, link, lat, lng, geo_precise, alert_sent_at, alert_sent_count, types_source, ...rest } = f;
    onSubmit({ ...rest, content: textToContent(contentText), embeds: textToEmbeds(embedsText) });
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="event-form">
      {!initial?.id && !hideImport && <ImportFromLink onImport={applyImport} />}
      <TextField label="Titre / line-up *" value={f.title} onChange={set("title")} required testId="event-form-title" />
      <Field label="Catégories (plusieurs possibles — laisse vide pour un classement automatique par l'IA)">
        <EventTypePicker value={f.types} onChange={set("types")} />
      </Field>
      <Field label="Date et heure *">
        <DateTimePicker value={f.date} onChange={set("date")} testId="event-form-date" />
      </Field>
      <div className="grid sm:grid-cols-2 gap-5">
        <TextField label="Lieu *" value={f.venue} onChange={set("venue")} required testId="event-form-venue" />
        <TextField label="Ville *" value={f.city} onChange={set("city")} required testId="event-form-city" />
      </div>
      <NewPlaceCategory venue={f.venue} value={f.place_category} onChange={set("place_category")} />
      <TextField label="Adresse" value={f.address} onChange={set("address")} testId="event-form-address" />
      <TextField label="Lien billetterie" value={f.ticket_url} onChange={set("ticket_url")} placeholder="https://shotgun.live/..." testId="event-form-ticket" />
      <TextField label="Image (URL)" value={f.image} onChange={set("image")} placeholder="https://..." testId="event-form-image" />
      <AreaField label="Résumé" value={f.excerpt} onChange={set("excerpt")} rows={3} testId="event-form-excerpt" />
      <AreaField label="Texte complet" value={f.contentText} onChange={set("contentText")} rows={8} testId="event-form-content" hint="Laisse une ligne vide entre chaque paragraphe." />
      <AreaField label="Vidéos / players" value={f.embedsText} onChange={set("embedsText")} rows={3} testId="event-form-embeds" hint="Un lien par ligne (YouTube, Bandcamp, Mixcloud, SoundCloud…)." />
      <button type="submit" disabled={submitting || !f.date} data-testid="event-form-submit" className="bg-primary text-white font-display uppercase text-lg px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200 disabled:opacity-50">
        Enregistrer
      </button>
    </form>
  );
};
